
import { mapGetters } from 'vuex'
import { Currency } from '~/plugins/Currency'
import Types from '../../static/database/Types.json'
import { convertToSlug } from '~/helpers/generate-slug'
export default {
  props: {
    item: {
      default: () => {
        return {
          imagePath: '',
          category: {
            id: -1,
            name: '',
          },
        }
      },
    },
    link: {
      default: '',
    },
    showLinkText: {
      default: '',
    },
    showLink: {
      default: false,
      type: Boolean,
    },
    showEvent: {
      default: false,
      type: Boolean,
    },
    pinned: {
      default: false,
      type: Boolean,
    },
    accordion: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      getRedirectUrl: 'getRedirectUrl',
      getUserIP: 'user/getUserIP',
    }),
    type() {
      return Types.find((t) => t.type === this.item.type)
    },
  },
  methods: {
    convertToSlug,
    Currency(p) {
      return Currency(p, this.getUserIP.currency)
    },
  },
}
